import axios from "axios";

export const Booking = {
    namespaced: true,
    state: {
        loading: true,
        bookingInProgress: false,
        isBookingDetails: true,
        isBookingPayment: false,
        isBookingComplete: false,
        showTicketDetails: true,
        showPayment: false,
        showScanStage: false,
        currentTicket: [],
        qrcodeData: '',
        scanTicketId: '',
        hasSubmitted: false,
        allTickets: [],
        ticketToBook: [],
        ticketNumbers: 0,
        ticket_expired_error: false,
        ticket_expired_error_msg: 'Something went wrong!',
        endOfDataOne: false,
        loadingNextDataSetOne: false,
        endOfDataTwo: false,
        loadingNextDataSetTwo: false,
        pageIndex: -10,
        dataTemp: [],
        prevDataCount: 0,
        entireticketdata: [],
    },
    getters: {
        allTickets: (state:any) => state.allTickets,
        currentTicket: (state: any) => state.currentTicket
    },
    mutations: {
        stopSubmitting(state: any) {
            state.hasSubmitted = false;
        },

        set_ticketDetails(state: any, tickets: any) {
            //stop when the tickets are done 
            if (state.endOfDataOne || state.endOfDataTwo) {
                return;
            }
            //process data sets
            if (tickets != undefined) {
                state.entireticketdata = tickets;              
            } else {
                tickets = state.entireticketdata;
            }

            var datacount = tickets.length;
            state.pageIndex = state.pageIndex + 10;
            if (datacount < state.pageIndex) {
                if ((datacount - state.prevDataCount) < 10) {
                    state.pageIndex = (state.pageIndex - 10) + (datacount - state.prevDataCount);
                    for(let i = state.prevDataCount; i < (state.prevDataCount+(datacount - state.prevDataCount)); i++) {
                        if (tickets[i] != undefined) {
                            state.dataTemp = [
                                ...state.dataTemp,
                                tickets[i]
                            ];
                        }
                    }
                    state.allTickets = [state.dataTemp];
                }
                state.endOfDataOne = true;
                state.endOfDataTwo = true;
                
            } else {
                if (state.pageIndex < 10 && datacount < 10) {
                    for(let i = state.prevDataCount; i < datacount; i++) {
                        if (tickets[i] != undefined) {
                            state.dataTemp = [
                                ...state.dataTemp,
                                tickets[i]
                            ];
                        }
                    }
                    state.allTickets = [state.dataTemp];
                    state.endOfDataOne = true;
                    state.endOfDataTwo = true;
                } else {
                    for(let i = state.prevDataCount; i < (state.prevDataCount+10); i++) {
                        if (tickets[i] != undefined) {
                            state.dataTemp = [
                                ...state.dataTemp,
                                tickets[i]
                            ];
                        }
                    }
                    state.allTickets = [state.dataTemp];
                }
            }
            state.prevDataCount = state.pageIndex;
            state.ticketNumbers = state.allTickets[0].length;
            state.loading = false;
            state.loadingNextDataSetOne = false;
            state.loadingNextDataSetTwo = false;
        },

        startBooking(state:any) {
            state.bookingInProgress = !state.bookingInProgress;
            
            let __getticketbyid = 'https://bookinga.herokuapp.com/api/v1/busSchedule/'

            let config = {
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem("jwt")
                }
            }

            if (state.currentTicket.length == 0) {
                let current_url_params = location.href.split('?')[1]
                if ( current_url_params ==  null) {
                    state.bookingInProgress = !state.bookingInProgress;
                    return;
                }

                let ticket_id = current_url_params.split('=')[1]
                
                axios.get(`${__getticketbyid}${ticket_id}`, config)
                    .then(response => {

                        if (response.data.message[0] == 'A') {
                            state.bookingInProgress = !state.bookingInProgress;
                            return;
                        }
                        state.currentTicket = response.data.message[0];
                       
                    }).catch((err) => {
                        state.bookingInProgress = !state.bookingInProgress;
                        return;
                    }) 
            }
        },

        returnToTicket(state: any) {
            state.showTicketDetails = !state.showTicketDetails;
            state.showPayment = !state.showPayment;
            state.isBookingPayment = !state.isBookingPayment;
        },
               
        setTicket(state:any, data:any) {
            state.currentTicket = data;
            //validate if ticket is date 
            let dateee = new Date();
            let dat = new Date(state.currentTicket.date);
            let time = state.currentTicket.starttime.split()[0]; ///time from db
            let date = dat.toISOString().split('T')[0]; //date from db
            let currentDate = dateee.toISOString().split('T')[0]; //current date
            let currentTime = dateee.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit' , hour12: false }); //current time
           
            if(date<currentDate) {
                state.ticket_expired_error = true;
                state.ticket_expired_error_msg = "This bus has already departed. Try booking the next bus";
                return;
            }
            if(date==currentDate && time<currentTime) {
                state.ticket_expired_error = true;
                state.ticket_expired_error_msg = "This bus has already departed. Try booking the next bus";
                return;
            }
            if (state.currentTicket.sits <= 0) {
                state.ticket_expired_error = true;
                state.ticket_expired_error_msg = "All the bus seats are booked! Try booking the next bus.";
                return;
            }
            if (state.currentTicket.price == null || state.currentTicket.price == undefined) {
                state.ticket_expired_error = true;
                state.ticket_expired_error_msg = "Sorry about this! The ticket has invalid price.";
                return;
            }
            state.bookingInProgress = !state.bookingInProgress;
        },

        removeBookingerrors(state: any) {
            state.ticket_expired_error = false;
            state.ticket_expired_error_msg = 'Something went wrong!';
        },

        bookTicket(state:any, data:any) {
            state.showTicketDetails = !state.showTicketDetails;
            state.showPayment = !state.showPayment;
            state.isBookingPayment = !state.isBookingPayment;
            state.ticketToBook = data;
        },

        scanThisTicket(state: any, data: any) {
            state.isBookingDetails = true;
            state.bookingInProgress = true;
            state.isBookingPayment = true;
            state.showScanStage = true;
            state.showPayment = false;
            state.showTicketDetails = false;
            state.isBookingComplete = true;
            state.qrcodeData = data.ticketid + '*' + data.buscompany + '*' + data.clientid + '*' + data.busplate + '*' + data.date + '*' + data.departure + '*' + data.destination + '*' + data.name + '*' + data.price + '*' + data.time;
            state.scanTicketId = data.id
        },        
        
        closeScanner(state: any) {
            state.bookingInProgress = false,
            state.isBookingDetails = true,
            state.isBookingPayment = false,
            state.isBookingComplete = false,
            state.showTicketDetails = true,
            state.showPayment = false,
            state.showScanStage = false,
            // state.isBookingDetails = false;
            // state.bookingInProgress = false;
            // state.isBookingPayment = false;
            // state.showScanStage = false;
            state.qrcodeData = '';
            state.scanTicketId = '';
        },

        payTicket(state:any, data: any) {
            state.hasSubmitted = true;

            let config = {
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem("jwt")
                }
            }
            
            let _ticketbooking = 'https://bookinga.herokuapp.com/api/v1/payment/bookingTicket';
            let _ticketpaymentmomo = 'https://bookinga.herokuapp.com/api/v1/payment/mobilemoney';
            let _ticketpaymentcard = 'https://bookinga.herokuapp.com/api/v1/payment/cards';
            let _ticketpaymentpaypal = 'https://bookinga.herokuapp.com/api/v1/payment/paypal';
            
            // let ticketdata: any = {
            //     "price": state.currentTicket.price,
            //     "scheduleId": state.currentTicket.scheduleId,
            //     "departure": state.ticketToBook.departure,
            //     "destination": state.ticketToBook.destination,
            //     "busCompany": state.ticketToBook.companyname,
            //     "yourName": state.ticketToBook.ticketowner,
            //     "date": state.ticketToBook.departdate,
            //     "time": state.ticketToBook.departtime
            // }    
            
            let ticketdata: any = {
                "price": state.currentTicket.price,
                "scheduleId": state.currentTicket.scheduleid,
                "departure": state.currentTicket.source,
                "destination": state.currentTicket.destination,
                "busCompany": state.currentTicket.companyname,
                "yourName": state.ticketToBook.ticketowner,
                "date": state.currentTicket.date,
                "time": state.currentTicket.starttime
            }    

            if (data.method == 'momo') {
                let paymentdata: any = {
                    "amount": ticketdata.price,
                    "fullname": data.momouser,
                    "email": data.email,
                    "phone_number": data.number
                }

                axios.post(_ticketpaymentmomo, paymentdata, config)
                    .then(response => {

                        localStorage.setItem('current_ticket_booking_data', JSON.stringify(ticketdata) );

                        let url = response.data.message.split(' ')[4];
                        window.location.replace(url);

                    }).catch(err => {
                        alert('Something went wrong. Retrying . . .');
                        location.reload();
                    })    
            }

            if (data.method == 'card') {

                let paymentdata: any = {
                    "card_number": data.card_number,
                    "cvv": parseInt(data.cvv),
                    "expiry_month": data.expiry_date.split('-')[0],
                    "expiry_year": data.expiry_date.split('-')[1],
                    "currency": "RWF",
                    "amount": ticketdata.price,
                    "fullname": data.fullnames,
                    "email": data.email_address,
                    "phone_number": data.phone_number
                }
    
                axios.post(_ticketpaymentcard, paymentdata, config)
                    .then(response => {
                        let url = response.data.message.split(' ')[4];
                        window.location.replace(url);

                    }).catch((err) => {
                        alert('Something went wrong. Retrying . . .');
                        location.reload();
                    })    
            }

            if (data.method == 'paypal') {
                let paymentdata: any = {
                    "price": ticketdata.price,
                }
    
                axios.post(_ticketpaymentpaypal, paymentdata, config)
                    .then(response => {
    
                        let url = response.data.message.split(' ')[4];
                        window.location.replace(url);

                    }).catch((err) => {
                        alert('Something went wrong. Retrying . . .');
                        location.reload();
                    })    
            }

        },
        
        loadNextDataSetOne(state: any) {
            state.loadingNextDataSetOne = !state.loadingNextDataSetOne;
        },

        loadNextDataSetTwo(state: any) {
            state.loadingNextDataSetTwo = !state.loadingNextDataSetTwo;
        },

        no_data_alert(state: any) {
            state.ticketNumbers = 0;
            state.loading = false;
        }
         
    },
    actions: {
        getTickets(context:any, user:any) {
            let config ={
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem("jwt")
                }
            }
            
            let _ticketsapi = 'https://bookinga.herokuapp.com/api/v1/busSchedule';
            
            axios.get(_ticketsapi, config)
                .then(response => {
                    if (response.data.message) {
                        if (response.data.message == "No schedules made yet") {
                            context.commit('no_data_alert');
                        }
                    } else {
                        if (response.data.data) {
                            context.commit('set_ticketDetails', response.data.data);
                        } else {
                            context.commit('no_data_alert');

                        }
                    }
                }).catch((err) => {})
        },

        bookTicketFinal() {
            const _bookingapi = 'https://bookinga.herokuapp.com/api/v1/payment/bookingTicket';
        }

    },
    modules: {}
}


